import ReactGA from "react-ga4";
import { hasAnalyticsConsent } from "./utils/cookieConsent";

let gaInitialised = false;

const getGtag = () => {
  window.dataLayer = window.dataLayer || [];

  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  return window.gtag;
};

export const setDefaultConsent = () => {
  const gtag = getGtag();

  gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  });
};

export const updateConsent = ({
  analytics = false,
  marketing = false,
} = {}) => {
  const gtag = getGtag();

  gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });
};

export const initGA = () => {
  if (gaInitialised) return;
  if (!process.env.REACT_APP_GA_ID) return;

  setDefaultConsent();

  ReactGA.initialize(process.env.REACT_APP_GA_ID, {
    gaOptions: {
      anonymizeIp: true,
    },
  });

  gaInitialised = true;
};

export const grantAnalyticsConsent = () => {
  initGA();
  updateConsent({ analytics: true });
};

export const grantMarketingConsent = () => {
  initGA();
  updateConsent({
    analytics: hasAnalyticsConsent(),
    marketing: true,
  });
};

export const applyStoredConsent = () => {
  initGA();

  updateConsent({
    analytics: hasAnalyticsConsent(),
    marketing:
      JSON.parse(localStorage.getItem("cookie_consent_v1") || "{}")
        ?.marketing === true,
  });
};

export const trackPage = (path) => {
  if (!hasAnalyticsConsent()) return;

  initGA();

  ReactGA.send({
    hitType: "pageview",
    page: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};